<template>
    <v-container fluid>
        <NewcarBanner></NewcarBanner>
        <NewcarServiceIntro></NewcarServiceIntro>
        <NewcarSteps></NewcarSteps>
        <NewcarWhyUs></NewcarWhyUs>
    </v-container>
</template>
<script>
import NewcarBanner from "../components/ui/NewcarBanner.vue";
import NewcarServiceIntro from "../components/ui/NewcarServiceIntro.vue";
import NewcarSteps from "../components/ui/NewcarSteps.vue";
import NewcarWhyUs from "../components/ui/NewcarWhyUs.vue";
export default {
  name: "Newcar",
  components: {
      NewcarBanner,
      NewcarServiceIntro,
      NewcarSteps,
      NewcarWhyUs
  }
};
</script>
<style scoped>
.service-introtable {
    table-layout: fixed;
}
</style>
